function getTimeRemaining(endtime) {
    var dateTime = endtime.split(' ');
    var date = dateTime[0].split('-');
    var yyyy = date[0];
    var mm = date[1] - 1; // remove 1 from the month
    var dd = date[2];

    var time = dateTime[1].split(':');
    var h = time[0];
    var m = time[1];
    var s = time[2];

    endtime = new Date(yyyy, mm, dd, h, m, s);

    var timeRemaining = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((timeRemaining / 1000) % 60);
    var minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
    var hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

    return {
        'total': parseFloat((timeRemaining < 10 ? '0' + timeRemaining : timeRemaining)),
        'days': parseFloat((days < 10 ? '0' + days : days)),
        'hours': parseFloat((hours < 10 ? '0' + hours : hours)),
        'minutes': parseFloat((minutes < 10 ? '0' + minutes : minutes)),
        'seconds': parseFloat((seconds < 10 ? '0' + seconds : seconds))
    };
}
if ($('.project-time-left').length) {
    var timer = $('.project-time-left');
    var countdown = timer.attr('data-end_date');
    var degreees = 0;

    var timerInterval = setInterval(function () {
        var time = getTimeRemaining(countdown);

        if (time.total <= 0) {
            // show the end time
            clearInterval(timerInterval);

            // remvoe the donation options and put in the thank you message
            $('.thank-you-outer-wrapper').show();
            $('.donation-outer-wrapper').remove();
        }

        timer.find('[data-input="days"]').html(time.days);
        timer.find('[data-input="hours"]').html(time.hours);
        timer.find('[data-input="minutes"]').html(time.minutes);
        timer.find('[data-input="seconds"]').html(time.seconds);

        // update the seconds
        if (degreees === 0) {
            degreees = (60 - time.seconds) * 6;
        } else {
            degreees += 6;
        }
        $('.clock .seconds').css({
            'transform': `rotate(${degreees}deg)`
        });

        // minutes 
        var minutes = 60 - time.minutes;
        var clock = $('.clock');
        var circumference = parseFloat(clock.find('.minutes').attr('stroke-dasharray'));
        var dashoffset = circumference * (1 - ((minutes * 1.6666666667) / 100));
        clock.find('.minutes').css({ strokeDashoffset: dashoffset + '' });

        if (time.total <= 0) {
            // show the end time
            clearInterval(timerInterval);
        }
        
    }, 1000);
}

$('body').on('click', '.campaign-usd .donate-trigger', function () {
    $('.modal.add-donation-usd .select-ticket-trigger').removeClass('active');
    $('.modal.add-donation-usd').addClass('other');
    $('.add-donation-usd input[name="amount"]').val('0');
    $('.modal.add-donation-usd .other-amount input').select();
    openModal('.add-donation-usd');
    return false;
});

$('body').on('click', '.to-about-trigger', function () {
    $('html, body').animate({
        scrollTop: $('.project').offset().top
    }, 300);

    return false;
});

$('body').on('click', '.to-tickets-trigger', function() {
    $('html, body').animate({
        scrollTop: $('.add-donation-usd .tickets').offset().top
    }, 300);
    
    return false;
});

function updateUSDTotals() {
    var amount = 0;
    $('.campaign-usd .select-ticket-trigger.active').each(function() {
        amount += parseFloat($(this).attr('data-amount'));
    });

    var additional = parseFloat($('.add-donation-usd .additional-amount input').val());
    additional = isNaN(additional) ? 0 : additional;
    amount += additional;


    $('.campaign-usd [data-input="total"]').html(amount.toFixed(2));
    $('.campaign-usd [name="amount"]').val(amount);
}

$('body').on('click', '.campaign-usd .select-ticket-trigger', function() {
    var $this = $(this);
    $this.toggleClass('active');
    updateUSDTotals();

    // var amount = $this.attr('data-amount');

    // $('.campaign-usd .select-ticket-trigger').removeClass('active');
    // $this.addClass('active');

    // $('.campaign-usd .other-amount input').val(amount);
    // $('.campaign-usd [name="amount"]').val(amount);
    // $('.campaign-usd .select-ticket-trigger').removeClass('active');
    // $('.campaign-usd .select-ticket-trigger[data-amount="' + amount + '"]').addClass('active');

    // $('.add-donation-usd').removeClass('other');
    // if ($this.parents('li').is(':last-child')) {
    //     $('.add-donation-usd').addClass('other');
    //     $('.campaign-usd .other-amount input').focus();
    //     $('.add-donation-usd .buy-tickets').addClass('visible');
    //     return false;
    // }

    // $('.add-donation-usd .buy-tickets').addClass('visible');

    // $('html, body').animate({
    //     scrollTop: $('.add-donation-usd .buy-tickets').offset().top
    // }, 300);

    // updateUSDTotals();
    return false;
});

$('body').on('click', '.to-additional-amount', function() {
    $('html, body').animate({
        scrollTop: $('.add-donation-usd .additional-amount').offset().top
    }, 300);

    $('.add-donation-usd .additional-amount input').select();
    
    return false;
});

$('body').on('keyup', '.add-donation-usd .additional-amount input', function() {
    // $('.campaign-usd .select-ticket-trigger').removeClass('active');
    updateUSDTotals();
    return false;
});

// $('body').on('click', '.campaign-usd .close-other-amount', function() {
//     $('.add-donation-usd').removeClass('other');
//     $('.campaign-usd .select-ticket-trigger').removeClass('active');
//     $('.campaign-usd .other-amount input').val('0');
//     $('.campaign-usd [name="amount"]').val('0');
    
//     return false;
// });

// $('body').on('blur', '.add-donation-usd .other-amount input', function() {
//     var $this = $(this);
//     var amount = parseFloat($this.val());
//     amount = isNaN(amount) ? 0 : amount;
//     $('.add-donation-usd [name="amount"]').val(amount);
//     return false;
// });

$('body').on('click', '.campaign-usd .open-donation-form', function() {
    var amount = parseFloat($('.add-donation-usd input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if(!amount) {
        showNotice('Error', 'Please choose an amount to donate', 'close');
        return false;
    }

    $('.add-donation-usd .buy-tickets').addClass('visible');
    $('html, body').animate({
        scrollTop: $('.add-donation-usd .buy-tickets').offset().top
    }, 300);
    
    return false;
});

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

// validate the promo code
function validateUSDPromo() {
    $('.promo .code-error, .promo .invalid').hide();

    if ($('.add-donation-usd input[name="amount"]').length && parseFloat($('.add-donation-usd input[name="amount"]').val()) <= 0) {
        $('.promo .code-error').show();
        $('input[name="coupon"]').val('');
        return false;
    }

    $.ajax({
        type: 'POST',
        url: '/coupons',
        data: {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'GET',
            'amount': $('.add-donation-usd input[name="amount"]').val(),
            'coupon': $('.add-donation-usd input[name="coupon"]').val()
        },
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                $('.add-donation-usd .promo label').hide();
                $('.add-donation-usd .promo .applied .code').html(data.code);
                $('.add-donation-usd .promo .applied .tickets').html(data.tickets);
                $('.add-donation-usd .promo .applied').show();
            } else {
                $('.add-donation-usd .promo .invalid').show();
            }
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
}

$('body').on('blur', '.add-donation-usd input[name="coupon"]', function() {
    validateUSDPromo();
    return false;
});


$('body').on('change', '.add-donation-usd [name="method"]', function() {
    var $this = $(this);
    var method = $this.val();
    
    if(method === 'card') {
        $('.add-donation-usd .card').parents('li').removeClass('hidden');
        $('.add-donation-usd .card').addClass('required');
        return false;
    }

    if(method === 'paypal') {
        $('.add-donation-usd .card').parents('li').addClass('hidden');
        $('.add-donation-usd .card').removeClass('required');
    }

});

// submit the donation
$('body').on('submit', '.add-donation-usd form', function() {
    var $this = $(this);

    var amount = parseFloat($('.add-donation-usd input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if(!amount) {
        showNotice('Error', 'Please choose an amount to donate', 'close');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required', $this).each(function() {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }

    loading();

    // check if we are paypal
    var payload = {};

    if ($('.add-donation-usd [name="method"]:checked').val() === 'paypal') {
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.first_name = $('input[name="first_name"]', $this).val();
        payload.last_name = $('input[name="last_name"]', $this).val();
        payload.street = $('input[name="street"]', $this).val();
        payload.city = $('input[name="city"]', $this).val();
        payload.state = $('input[name="state"]', $this).val();
        payload.zip = $('input[name="zip"]', $this).val();
        payload.email = $('input[name="email"]', $this).val();
        payload.phone = $('input[name="phone"]', $this).val();
        payload.coupon = $('input[name="coupon"]', $this).val();
        payload.amount = $('input[name="amount"]', $this).val();
        payload.source = $('input[name="source"]', $this).val();
        payload.team = $('[name="team"]', $this).val();
        payload.message = $('[name="message"]', $this).val();
        payload.method = $('input[name="method"]:checked', $this).val();
        payload.currency = 'USD';

        if ($('input[name="anonymous"]', $this).prop('checked')) {
            payload.anonymous = true;
        }

        $.ajax({
            type: 'POST',
            url: $this.attr('action'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                console.log(data);
                
                if (!data.success) {
                    unloading();
                    showNotice('Error', data.message, 'close');
                    return false;
                }
                
                if(data.location) {
                    window.location.href = data.location;
                    return false;
                }
                
                unloading();
                $this[0].reset();
                closeModal();
                showNotice('Success', data.message, 'close');
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });

        return false;
    }

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload.first_name = $('input[name="first_name"]', $this).val();
    payload.last_name = $('input[name="last_name"]', $this).val();
    payload.street = $('input[name="street"]', $this).val();
    payload.city = $('input[name="city"]', $this).val();
    payload.state = $('input[name="state"]', $this).val();
    payload.zip = $('input[name="zip"]', $this).val();
    payload.email = $('input[name="email"]', $this).val();
    payload.phone = $('input[name="phone"]', $this).val();
    payload.coupon = $('input[name="coupon"]', $this).val();
    payload.amount = $('input[name="amount"]', $this).val();
    payload.source = $('input[name="source"]', $this).val();
    payload.team = $('[name="team"]', $this).val();
    payload.message = $('[name="message"]', $this).val();
    payload.method = $('input[name="method"]:checked', $this).val();
    payload.card_number = $('input[name="card_number"]', $this).val();
    payload.cvv =  $('input[name="cvv"]', $this).val();
    payload.expiry = $('input[name="expiry"]', $this).val();
    payload.currency = 'USD';

    if ($('input[name="anonymous"]', $this).prop('checked')) {
        payload.anonymous = true;
    }

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            
            if (!data.success) {
                unloading();
                showNotice('Error', data.message, 'close');
                return false;
            }
            
            unloading();
            $this[0].reset();
            closeModal();
            showNotice('Success', data.message, 'close');
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    // // setup the token
    // Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
    // Stripe.card.createToken(
    //     {
    //         name: $('input[name="first_name"]', $this).val() + ' ' + $('input[name="last_name"]', $this).val(),
    //         number: $('input[name="card_number"]', $this).val(),
    //         cvc: $('input[name="cvv"]', $this).val(),
    //         exp: $('input[name="expiry"]', $this).val(),
    //         // exp_month: $('input[name="month"]', $this).val(),
    //         // exp_year: $('input[name="year"]', $this).val(),
    //         address_line1: $('input[name="street"]', $this).val(),
    //         address_state: $('input[name="state"]', $this).val(),
    //         address_zip: $('input[name="zip"]', $this).val()
    //     },
    //     function(status, response) {
    //         // console.log(response);
    //         if (response.error) {
    //             unloading();
    //             showNotice('Error', response.error.message, 'close');
    //             return false;
    //         }

    //         payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    //         payload.stripe_token = response.id;

    //         payload.first_name = $('input[name="first_name"]', $this).val();
    //         payload.last_name = $('input[name="last_name"]', $this).val();
    //         payload.street = $('input[name="street"]', $this).val();
    //         payload.city = $('input[name="city"]', $this).val();
    //         payload.state = $('input[name="state"]', $this).val();
    //         payload.zip = $('input[name="zip"]', $this).val();
    //         payload.email = $('input[name="email"]', $this).val();
    //         payload.phone = $('input[name="phone"]', $this).val();
    //         payload.brand = response.card.brand;
    //         payload.last_four = response.card.last4;
    //         payload.month = response.card.exp_month;
    //         payload.year = response.card.exp_year;
    //         payload.coupon = $('input[name="coupon"]', $this).val();
    //         payload.amount = $('input[name="amount"]', $this).val();
    //         payload.source = $('input[name="source"]', $this).val();
    //         payload.team = $('[name="team"]', $this).val();
    //         payload.message = $('[name="message"]', $this).val();
    //         payload.method = $('input[name="method"]:checked', $this).val();
    //         // payload.method = 'card';
    //         payload.currency = 'USD';

    //         if ($('input[name="anonymous"]', $this).prop('checked')) {
    //             payload.anonymous = true;
    //         }

    //         $.ajax({
    //             type: 'POST',
    //             url: $this.attr('action'),
    //             data: payload,
    //             dataType: 'json',
    //             success: function(data) {
    //                 console.log(data);
    //                 unloading();

    //                 if (!data.success) {
    //                     showNotice('Error', data.message, 'close');
    //                     return false;
    //                 }

    //                 $this[0].reset();
    //                 closeModal();
    //                 $('.donation-thanks-usd [data-input="header"]').html(data.header);
    //                 $('.donation-thanks-usd [data-input="message"]').html(data.message);
    //                 openModal('.donation-thanks-usd', 500, true);

    //                 // $('.donation-thanks-usd .up-sale').hide();
    //                 // if (data.up_sale) {
    //                 //     $('.donation-thanks-usd .up-sale').show();
    //                 //     $('.donation-thanks-usd .up-sale [data-input="upsale_message"]').html(data.up_sale.message);
    //                 //     $('.donation-thanks-usd .up-sale .buy-more').html(data.up_sale.button);
    //                 //     $('.donation-thanks-usd .up-sale .buy-more').attr('data-donation', data.up_sale.donation);
    //                 //     $('.donation-thanks-usd .up-sale .buy-more').attr('data-card_token', data.up_sale.card_token);
    //                 //     $('.donation-thanks-usd .up-sale .buy-more').attr('data-currency', data.up_sale.currency);
    //                 //     $('.donation-thanks-usd .up-sale .buy-more').attr('data-amount', data.up_sale.amount);
    //                 // }

    //                 // $this[0].reset();
    //                 // closeModal();
    //                 // showNotice('Success', data.message, 'close');
    //             },
    //             error: function(request) {
    //                 console.log(request.responseText);
    //             }
    //         });

    //         return false;
    //     }
    // );

    return false;
});

$('body').on('click', '.donation-thanks-usd .buy-more', function () {
    var $this = $(this);
    var payload = {};
    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload['card_token'] = $this.attr('data-card_token');
    payload['amount'] = $this.attr('data-amount');

    loading();
    $.ajax({
        type: 'POST',
        url: `donation/${$this.attr('data-donation')}/more`,
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showNotice('Error', data.message, 'close');
                return false;
            }

            closeModal();
            $('.donation-thanks-usd [data-input="header"]').html(data.header);
            $('.donation-thanks-usd [data-input="message"]').html(data.message);
            openModal('.donation-thanks-usd', 500, true);

            $('.donation-thanks-usd .up-sale').hide();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('click', '.open-campaign-rules-usd', function () {
    openModal('.campaign-rules-usd');
    return false;
});


// recent donations
$('body').on('click', '.sort-donations-trigger', function () {
    var $this = $(this);
    closeDropdown();

    $.ajax({
        type: 'POST',
        url: 'donations',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            page: $this.attr('data-page'),
            sort: $this.attr('data-sort'),
            search: $('.recent-donors .search input[name="search"]').val()
        },
        dataType: 'json',
        success: function (data) {
            // console.log(data);

            // empty the current donations
            $('.donors ul .donor').remove();

            // add new donations
            $.each(data.results.donations, function (index, donation) {
               $('.donors ul').append(`<li class="donor" data-donation="${donation.donation}">
                <div class="details">
                    <div class="name-amount">
                        <div class="name">
                            <h6 data-input="full_name">${donation.full_name}</h6>
                            <time data-input="donation_date_human">${donation.donation_date_human}</time>
                            <p class="team">${donation.team}</p>
                        </div>

                        <div class="amount" data-input="amount_floored">${donation.amount_floored}</div>
                    </div>

                    <p class="message" data-input="message">${donation.message}</p>
                </div>
                </li>`);
            });

            // update the load more button
            $('.load-more-donors-wrapper').addClass('hidden');
            if (data.results.pagination['next-pages'].length) {
                $('.load-more-donors-wrapper').removeClass('hidden');

                // update the load more button
                $('.load-more-donors').attr('data-page', data.results.pagination['next-pages'][0]);
                $('.load-more-donors').attr('data-sort', data.results.sort);
            }


        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});

$('body').on('keyup', '.recent-donors .search input[name="search"]', function () {
    $.ajax({
        type: 'POST',
        url: 'donations',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            page: 1,
            sort: $('.load-more-donors').attr('data-sort'),
            search: $('.recent-donors .search input[name="search"]').val()
        },
        dataType: 'json',
        success: function (data) {
            // console.log(data);

            // empty the current donations
            $('.donors ul .donor').remove();

            // add new donations
            $.each(data.results.donations, function (index, donation) {
                console.log(donation);
                $('.donors ul').append(`<li class="donor" data-donation="${donation.donation}">
                <div class="details">
                    <div class="name-amount">
                        <div class="name">
                            <h6 data-input="full_name">${donation.full_name}</h6>
                            <time data-input="donation_date_human">${donation.donation_date_human}</time>
                            <p class="team">${donation.team}</p>
                        </div>

                        <div class="amount" data-input="amount_floored">${donation.amount_floored}</div>
                    </div>

                    <p class="message" data-input="message">${donation.message}</p>
                </div>
                </li>`);
            });

            // update the load more button
            $('.load-more-donors-wrapper').addClass('hidden');
            if (data.results.pagination['next-pages'].length) {
                $('.load-more-donors-wrapper').removeClass('hidden');

                // update the load more button
                $('.load-more-donors').attr('data-page', data.results.pagination['next-pages'][0]);
                $('.load-more-donors').attr('data-sort', data.results.sort);
            }


        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});

$('body').on('click', '.load-more-donors', function () {
    var $this = $(this);
    closeDropdown();

    $.ajax({
        type: 'POST',
        url: 'donations',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            page: $this.attr('data-page'),
            sort: $this.attr('data-sort'),
            search: $('.recent-donors .search input[name="search"]').val()
        },
        dataType: 'json',
        success: function (data) {
            // add new donations
            $.each(data.results.donations, function (index, donation) {
                console.log(donation);
                if ($('.donor[data-donation="' + donation.donation + '"]').length) {
                    return true;
                }

                $('.donors ul').append(`<li class="donor" data-donation="${donation.donation}">
                <div class="details">
                    <div class="name-amount">
                        <div class="name">
                            <h6 data-input="full_name">${donation.full_name}</h6>
                            <time data-input="donation_date_human">${donation.donation_date_human}</time>
                            <p class="team">${donation.team}</p>
                        </div>

                        <div class="amount" data-input="amount_floored">${donation.amount_floored}</div>
                    </div>

                    <p class="message" data-input="message">${donation.message}</p>
                </div>
                </li>`);
            });

            // update the load more button
            $('.load-more-donors-wrapper').addClass('hidden');
            if (data.results.pagination['next-pages'].length) {
                $('.load-more-donors-wrapper').removeClass('hidden');

                // update the load more button
                $('.load-more-donors').attr('data-page', data.results.pagination['next-pages'][0]);
                $('.load-more-donors').attr('data-sort', data.results.sort);
            }


        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});

// process-campaign
channel.bind('process-campaign', function (data) {
    console.log(data);

    var stats;

    if ($('.project-stats-usd').length) {
        stats = $('.project-stats-usd');
        // update the totals
        stats.find('[data-input="total_donated_floored"]').html(data.total_donated_floored);

        // update the progress bars
        stats.find('.project-progress .current-progress').css({
            width: data.percent_donated + '%'
        });

        // update the tooltip
        stats.find('.project-progress .tool-tip span').html(data.percent_donated_parsed);
        stats.find('.project-progress .tool-tip').css({
            left: data.percent_donated + '%'
        });

        return;
    }

    if ($('.project-stats-ils').length) {
        stats = $('.project-stats-ils');
        // update the totals
        stats.find('[data-input="total_donated_floored"]').html(data.total_donated_floored);

        // update the progress bars
        stats.find('.project-progress .current-progress').css({
            width: data.percent_donated + '%'
        });

        // update the tooltip
        stats.find('.project-progress .tool-tip span').html(data.percent_donated_parsed);
        stats.find('.project-progress .tool-tip').css({
            right: data.percent_donated + '%'
        });
        return;
    }
});
channel.bind('process-donation', function (data) {
    console.log(data);

    if ($('.donors').length) {
        $('.donors ul').prepend(`<li class="donor" data-donation="${data.donation}">
            <time data-input="donation_date_human">${data.donation_date_human}</time>

            <div class="flex-wrapper">
                <div class="donor-info">
                    <p data-input="full_name">${data.full_name}</p>
                    <p class="message" data-input="message">${data.message}</p>
                </div>

                <div class="amount" data-input="amount_floored">${data.amount_floored}</div>
            </div>

            <div class="border"></div>
        </li>`);
    }
});